module.exports = __webpack_public_path__ + "img/btn2.5db4a03.png";